// sessionStorage key set once the post-login default presence has been applied in this browser session.
export const LOGIN_DEFAULT_PRESENCE_APPLIED_KEY = "loginDefaultPresenceApplied"
